import React from "react";
import { Mail, MapPin, Globe, ExternalLink } from "lucide-react";

export default function Contact() {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Contact Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to start a partnership? Get in touch with our team for
            collaborations and research opportunities.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center">
                <span
                  className="w-2 h-8 rounded mr-4"
                  style={{
                    background:
                      "linear-gradient(180deg,#93C754,#7FB740,#5C8A24)",
                  }}
                ></span>
                Get In Touch
              </h2>
            </div>
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ color: "#7FB740" }}
                >
                  <MapPin size={28} />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">
                    Our Location
                  </h3>
                  <p className="text-gray-600 text-lg">
                    Mytilene, Lesvos Island
                    <br />
                    North Aegean, Greece
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ color: "#7FB740" }}
                >
                  <Mail size={28} />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">
                    Email Us
                  </h3>
                  <a
                    href="mailto:info@trlab.eu"
                    className="text-[#7FB740] hover:text-[#6ea436] text-lg font-semibold transition-colors"
                  >
                    info@trlab.eu
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ color: "#7FB740" }}
                >
                  <Globe size={28} />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">
                    Partnerships
                  </h3>
                  <p className="text-gray-600 text-lg">
                    We welcome collaborations with organizations, institutions,
                    and communities across Europe and beyond.
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-8">
              <a
                href="mailto:info@trlab.eu"
                className="group w-full text-white px-8 py-4 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center space-x-3"
                style={{ backgroundColor: "#7FB740" }}
              >
                <Mail size={20} />
                <span>Send us a message</span>
                <ExternalLink
                  size={20}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </a>
            </div>
          </div>
          <div className="space-y-8">
            <div className="relative w-full h-96 rounded-3xl overflow-hidden shadow-xl border border-gray-200 bg-gray-100">
              <img
                src="/lesvos.webp"
                alt="Lesvos Island"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-gradient-to-br from-gray-50 via-gray-200 to-gray-50 p-8 rounded-3xl shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Why Lesvos?
              </h3>
              <div className="space-y-4 text-gray-700">
                <p className="text-lg leading-relaxed">
                  Located at the crossroads of Europe, Asia, and Africa, Lesvos
                  Island provides a unique vantage point for understanding and
                  addressing complex global challenges.
                </p>
                <p className="text-lg leading-relaxed">
                  The Aegean region serves as our natural laboratory for
                  developing and testing innovative solutions in climate
                  resilience, security, and governance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
